import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import axios from "axios";
import { Lock, User } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      localStorage.setItem("adminToken", response.data.access_token);
      toast.success("Login successful!");
      navigate("/admin");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md p-8 shadow-xl border-0">
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_48bcd539-ef2e-44cd-bd5d-721585fa8242/artifacts/5hg2aby0_image.png" 
            alt="CLIC Logo" 
            className="h-12 w-auto mx-auto mb-4"
          />
          <h1 className="font-display text-2xl font-bold text-[#1E293B]">Admin Login</h1>
          <p className="text-slate-500 text-sm mt-2">Sign in to manage CLIC Inner Circle</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="username" className="text-slate-700 font-medium">Username</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <Input
                id="username"
                type="text"
                placeholder="Enter username"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                required
                className="h-12 pl-10"
                data-testid="input-username"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-slate-700 font-medium">Password</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <Input
                id="password"
                type="password"
                placeholder="Enter password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
                className="h-12 pl-10"
                data-testid="input-password"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 btn-primary-gradient text-white font-semibold rounded-lg"
            data-testid="login-btn"
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="text-sm text-slate-500 hover:text-[#FF6B35] transition-colors">
            ← Back to Landing Page
          </a>
        </div>

        <div className="mt-8 p-4 bg-slate-50 rounded-lg">
          <p className="text-xs text-slate-500 text-center">
            <strong>Default credentials:</strong><br />
            Username: admin | Password: clic2024
          </p>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;
